
  <ng-container *ngIf="message; else default">
    <div class="message">{{message}}</div>
  </ng-container>
  <ng-template #default>
    <div>{{"error.try-again" | translate: 'EN' }}</div>
  </ng-template>
  <div class="row" id="error-img">
  <img src="../assets/images/error_img.png" alt=""/>
  </div>
